export const Cards = (() => {
	'use strict';

	function init() {
	}

	return {
		init: init,
	};
})();
